/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import { GET_PRODUCT_COUNT_FOR_PAGINATION, GET_PRODUCT_WITH_PAGINATION } from "../../../apollo/gql/query/products.query";
import { CLOUD_ASSETS_URL, CLOUD_FRONT_URL } from "../../../aws.config";
import { Spinner } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { addNewCustomFabricAtom, alankaramDataAtom, beforeSelectedImageScaletom, cropperSelectionAtom, fabricAtom, navigatedProductAtom, searchQueryAtom, selectedCustomFabricAtom, selectedPartAtom, uploadImageAtom } from "../../../state";
import { useRecoilState, useRecoilValue } from "recoil";
import InfiniteScroll from "react-infinite-scroll-component";
import { DEFAULT_PRODUCT_STATUS } from "../../../lib/constants/filters";
export interface ProductFilterInput {
  name: string[];
  companyId: string;
  imageTags: string[];
  category: string;
  materialCategory: string[];
  status: string;
  offset: number;
  limit: number;
  sort: string;
  withNoStyle: boolean;
  productType: string[];
  createdBy: string[];
  reviewedBy: string[];
  productListEditStatus: string;
  productSegmentStatus: string;
  productCategories: string[];
  storeCategory: string[];
  storeSubCategory: string[];
  folders: string[];
  productStatus?: String;
}

const Products: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get category from URL params, default to "All Products"
  const selectedCategory = searchParams.get('category') || "All Products";
  const search = searchParams.get('search')
  const [, setUploadImage] = useRecoilState(uploadImageAtom)
  const [, setCropperData] = useRecoilState(cropperSelectionAtom)
  const [, setInputSetValue] = useRecoilState(beforeSelectedImageScaletom);
  const [, setSelectedCustomFabricAtom] = useRecoilState(selectedCustomFabricAtom)
  const [fabricAtomState, setFabricsAtomState] = useRecoilState(fabricAtom);
  const [offset, setOffset] = useState(0);
  const [products, setProducts] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [, setSelectedPart] = useRecoilState(selectedPartAtom);
  const [, setNavigatedProduct] = useRecoilState(navigatedProductAtom)
  const [searchQuery, setSearchQuery] = useRecoilState(searchQueryAtom)
  const alankaramData = useRecoilValue(alankaramDataAtom);


  const initialInput: ProductFilterInput = {
    name: [],
    companyId: alankaramData?.companyId || "",
    imageTags: [],
    category: "",
    materialCategory: [],
    status: "",
    offset: 0,
    limit: 40,
    sort: "latest",
    withNoStyle: true,
    productType: [],
    createdBy: [],
    reviewedBy: [],
    productListEditStatus: "all",
    productSegmentStatus: "all",
    productCategories: [],
    storeCategory: [],
    storeSubCategory: [],
    folders: [],
    productStatus: alankaramData?.companyId === "63e0c85267e6ab00082da07e" ? "" : DEFAULT_PRODUCT_STATUS
  };

  const [loadProducts, { data, loading }] = useLazyQuery(GET_PRODUCT_WITH_PAGINATION);
  const [productCount, { data: countTotalProducts }] = useLazyQuery(GET_PRODUCT_COUNT_FOR_PAGINATION);

  useEffect(() => {
    if (data?.getProductWithPagination) {
      const newData = data.getProductWithPagination;

      if (offset === 0) {
        setProducts(newData);
      } else {
        setProducts((prev) => [...prev, ...newData]);
      }

      if (newData.length < 40) {
        setHasMore(false);
      }
    }
  }, [data]);

  const scrollTop = () => {
    const el = document.querySelector('.partsDisplay');
    if (el) {
      const topPosition = el.getBoundingClientRect().top + window.pageYOffset - 80;

      window.scrollTo({
        top: topPosition,
        behavior: 'smooth',
      });
    }
  };


  const fetchNext = () => {
    if (!hasMore || !Boolean(products?.length)) return;
    const newOffset = offset + 40;
    setOffset(newOffset);
    loadProducts({
      variables: {
        ...initialInput,
        productCategories: selectedCategory === "All Products" ? [] : [selectedCategory],
        offset: newOffset,
      },
    })
  };


  const loadInitialProducts = (name: string, searchQuery = "") => {
    const categoryFilter = name === "All Products" ? [] : [name];
    const searchFilter = searchQuery ? [searchQuery] : [];

    setOffset(0);
    setProducts([]);
    setHasMore(true);

    const variables = {
      ...initialInput,
      productCategories: categoryFilter,
      name: searchFilter,
      offset: 0,
    };

    loadProducts({ variables });
    productCount({ variables });

  }

  useEffect(() => {
    const searchQuery = searchParams.get("search") ?? "";
    loadInitialProducts(selectedCategory, searchQuery);
  }, [alankaramData?.companyId,searchQuery]);



  const handleCategoryClick = (name: string) => {
    if (name === selectedCategory) {
      scrollTop();
      return;
    }
    scrollTop();
    setSearchParams(prev => {
      if (name === "All Products") {
        prev.delete('category');
      } else {
        prev.set('category', name);
      }
      return prev;
    });

    const searchQuery = searchParams.get("search") ?? "";
    loadInitialProducts(name, searchQuery);
  };


  const categoryParam = searchParams.get("category") ?? "All Products";
  const matchedCategory: any = alankaramData?.parts?.find((cat: any) => cat?.key?.toLowerCase() === categoryParam?.toLowerCase());

  const [, setAddNewCustomFabric] = useRecoilState(addNewCustomFabricAtom)

  const CategoryCard = ({
    category,
    selectedCategory,
    onClick,
    isCompact = false,
  }: {
    category: any;
    selectedCategory: string;
    onClick: () => void;
    isCompact?: boolean;
  }) => {
    const isSelected = category.key === selectedCategory;

    return (
      <div
        onClick={onClick}
        className={`flex-shrink-0 rounded-md cursor-pointer overflow-hidden flex flex-col justify-between ${!isSelected ? 'border' : 'borderBlack'
          } ${isCompact ? 'max-w-[200px]' : ''}`}
      >
        <div className="flex-1 flex flex-col">
          <div className="aspect-w-16 aspect-h-9">
            <img
              className="w-full h-full object-cover max-h-full"
              alt={category?.name}
              src={category?.image}
            />
          </div>
        </div>
        <div
          className={`font-medium ${isSelected ? 'text-black' : 'text-gray-600'
            } text-sm text-center py-3`}
        >
          {category?.name}
        </div>
      </div>
    );
  };


  return (
    <>
      <Header />
      <div className="bg-gray-100 min-h-screen">
        {/* Hero Section */}
        <section className="relative">
          <div className="relative w-full h-[467px]">
            <img
              className="w-full h-[464px] object-cover absolute inset-0"
              alt="Hero background"
              src={alankaramData?.heroImage}
            />
            <div className="absolute inset-0 bg-black bg-opacity-50" />

            {/* Hero Content */}
            <div className="relative pt-[83px] h-[464px] flex flex-col items-center justify-center">
              <div className="border-t border-white w-24 mb-6"></div>
              <h1 className="font-bold text-white text-3xl md:text-4xl lg:text-5xl text-center tracking-tight leading-tight mb-6">
                {alankaramData?.headingTagline}
              </h1>
              <div className="border-t border-white w-24"></div>

              <p className="font-normal text-white text-lg md:text-[17px] text-center leading-7 mb-12 max-w-2xl px-4">
                {alankaramData?.subHeadingTagline}
              </p>

            </div>
          </div>
        </section>

        {/* Category Section */}
        <section className="bg-white py-8 partsDisplay">
          {alankaramData?.parts?.length <= 6 ? (
            <div className="gap-6 px-6 flex overflow-x-auto">
              {alankaramData?.parts?.map((category: any, ci: number) => (
                <CategoryCard
                  key={ci}
                  category={category}
                  selectedCategory={selectedCategory}
                  onClick={() => handleCategoryClick(category.key)}
                  isCompact
                />
              ))}
            </div>
          ) : (
            <div className="grid gap-6 px-6 gridTemplateColumns">
              {alankaramData?.parts?.map((category: any, ci: number) => (
                <CategoryCard
                  key={ci}
                  category={category}
                  selectedCategory={selectedCategory}
                  onClick={() => handleCategoryClick(category.key)}
                />
              ))}
            </div>
          )}
        </section>


        {/* Main Content */}
        <div className="container-fluid px-0 bg-gray-100">
          <div className="row gx-0">
            {/* Sidebar Navigation */}
            <div className="col-md-2 d-none d-md-block">
              <nav className="py-6 pl-12 bg-white h-[calc(100vh-80px)] sticky top-[80px]">
                {alankaramData?.parts?.map((item: any, i: number) => (
                  <div
                    key={i}
                    onClick={() => handleCategoryClick(item.key)}
                    className={`mb-8 font-medium ${selectedCategory === item.key
                      ? "text-black underline"
                      : "text-gray-600 hover:text-black"
                      } text-sm cursor-pointer transition-colors`}
                  >
                    {item.name}
                  </div>
                ))}
              </nav>
            </div>

            {/* Product Grid */}
            <div className="col-md-10">
              {
                products?.length === 0 && !loading ? (
                  <div className="my-5 flex items-center justify-center flex-col">
                    <div className="w-full min-h-[25rem] flex flex-col items-center justify-center text-center">
                      <h2>No matching for <b>'{search ?? selectedCategory}'</b>.</h2>
                      <p className="text-gray">But don't give up – check the filters, spelling or try less specific search terms.</p>
                    </div>
                  </div>
                ) : null
              }
              <div id="scrollableDiv" className="scrollableDivProducts overflow-visible" style={{ padding: "1rem" }} >
                <InfiniteScroll
                  dataLength={products.length}
                  next={fetchNext}
                  hasMore={hasMore}
                  loader={<></>}
                  className="row g-4 p-2"
                  scrollThreshold={0.8}

                >
                  <div className={products?.length === 0 ? "hidden" : "col-12"}>
                    <div className="h-100 border bg-white border-gray-200 overflow-hidden p-4 font-medium text-black text-sm">
                      {countTotalProducts?.getProductCountForPagination?.count || 0} results for {search ? `'${search}' in '${selectedCategory}'` : `'${selectedCategory}'`}
                    </div>
                  </div>

                  {products?.map((product: any, index) => {
                    const productData = product?.product || product;
                    const joinedTitles: any = productData?.storeSubCategories?.map((cat: any) => cat?.title).join(", ");
                    return (
                      <div key={index} className="col-12 col-sm-6 col-lg-4 col-xl-3 cursor-pointer">
                        <div
                          onClick={() => {
                            setUploadImage({})
                            setCropperData({})
                            setSelectedPart(null)
                            setSelectedCustomFabricAtom({ id: '' })
                            setFabricsAtomState({
                              ...fabricAtomState,
                              partWiseFabric: {},
                            })
                            setInputSetValue({})
                            setAddNewCustomFabric([]);
                            setNavigatedProduct(productData)
                            navigate(`/products/product-detail/${productData?._id}`)
                          }}
                          className="h-100 border bg-white border-gray-200 overflow-hidden transition-shadow hover:shadow-md"
                        >
                          {productData?.thumb ? (
                            <img
                              className="w-full h-64 object-contain"
                              alt={productData?.name}
                              src={`${CLOUD_FRONT_URL}${productData?.thumb}`}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = `${CLOUD_ASSETS_URL}img/no-3D-product-img.webp`;
                              }}
                            />
                          ) : (
                            <img
                              className="w-full h-64 object-contain"
                              alt={productData?.name}
                              src={`${CLOUD_ASSETS_URL}img/no-3D-product-img.webp`} />
                          )}
                          <div className="p-4">
                            <div className="text-gray-12 text-sm font-medium mb-1">
                              {productData?.sku || productData?.uniqueCode} - {joinedTitles}
                            </div>
                            <div className="text-gray-800 text-sm leading-snug">
                              {productData?.name}
                            </div>
                          </div>
                        </div>

                      </div>
                    );
                  })}
                  {loading && (
                    <div className="flex justify-center items-center mt-5">
                      <Spinner />
                    </div>
                  )}
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;

